import { render, staticRenderFns } from "./AboutOcean.vue?vue&type=template&id=db0417ca&scoped=true&"
import script from "./AboutOcean.vue?vue&type=script&lang=js&"
export * from "./AboutOcean.vue?vue&type=script&lang=js&"
import style0 from "./AboutOcean.vue?vue&type=style&index=0&id=db0417ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0417ca",
  null
  
)

export default component.exports